<script>
  import CommonFormElementMixin from './mixins/CommonFormElement'
  import { Datetime } from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  export default {
    mixins: [CommonFormElementMixin],
    components: {
      datetime: Datetime
    }
  }
</script>

<template>
  <div class="md-form">
    <label class="mr-5 active">{{ label }}</label>
    <datetime
      v-model="localValue"
      :inputClass="{ 'form-control': true, 'is-invalid': error }"
      :auto="true"
    ></datetime>
    <FormError v-if="error" :error="error" />
  </div>
</template>

<style lang="scss">
</style>


